
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "@mui/material";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const PackingListExcelDownload = () => {
 
  const handleDownload = async () => {
    try {
      // Fixed params
      const payload = {
        p_companyid: 13,
        p_finyearid: 1,
        p_parentinvoiceorderid: 83,
      };

      // API call using your helper
      const endpoint = API_ENDPOINTS.DownloadPackingListExcelReport;
      const response = await callApi(
        endpoint,
        "POST",
        { "Content-Type": "application/json" },
        payload
      );

      if (!response || response.length === 0) {
        alert("No packing list data found!");
        return;
      }

      // Convert JSON to Excel
      const worksheet = XLSX.utils.json_to_sheet(response);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "PackingList");

      // Export file
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(fileData, "PackingList.xlsx");
    } catch (error) {
      console.error("Error fetching packing list:", error);
      alert("Failed to fetch packing list data!");
    }
  };

  

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleDownload}
      sx={{ textTransform: "none" }}
    >
      Download Packing List(Excel)
    </Button>
  );
};

export default PackingListExcelDownload;
